export function Reducer(state, action) {
  switch (action.type) {
    case "loadMaymentMethod":
      return {
        ...state,
        paymentMethod: action.paymentMethod,
      };
    case "loadBillingInformation":
      return {
        ...state,
        billingInformation: action.billingInformation,
      };
    default:
      throw new Error();
  }
}
